import {
  UpdateDocumentDetailDto,
  UpdateDocumentDto,
} from '../../../../../server-api-hrm.type'
import { BASE_URL } from '../../../../../utils/config.base-url'

export const URL_ENDPOINT_DOCUMENT_DETAIL = `${BASE_URL}/document-detail`
export const DOCUMENT_DETAIL_PREFIX_URL = '/document-detail'
export const URL_ENDPOINT_DOCUMENT_DETAIL_APPROVAL_LOG = `${BASE_URL}/document-detail-approval-log/list/by-document-detail`

export type UpdateFormType = {
  doc: UpdateDocumentDto
  docDetail: UpdateDocumentDetailDto
}
